import React from "react";
import "./blogs.css";
import ajeet_2 from "./ajeet-2.webp";
import ajeet_4 from "./ajeet-4.webp";


const Ajeet_Kushwaha = () => {
  return (
    <div className="blog">
      <div className="row blog-row">
        <div className="col-md-4">
        <img
        src="placement-postulates/dp/Ajeet-khushwaha.jpg"
        style={{ height: "315px", width: "75%" }}
        alt="Ajeet"
      ></img>
        </div>
        <div className="col-md-8">
          <div className="blog-head">
            <h2>Ajeet Kushwaha</h2>
            <small> Deloitte</small>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Introduction </h3>
            <p>
              Hi everyone. Myself Ajeet Kushwaha and I’m placed in Deloitte as a
              consultant. This is my story of how I navigated my way to
              placement. Although many of you might me knowing me as I have
              consistently shared semester related materials and placement
              materials in groups, but through this postulate I’ll try to reach
              a wide audience. <br />
              Many of us are often shy to ask seniors for any help and guidance
              and end up doing wrong things. Later we realize that “someone
              should have guided us”. Let’s say this ‘someone’ is me.
            </p>
          </div>
        </div>
        <img
          class="blog-image-right"
          src="placement-postulates/blogs/Ajeet-Kushwaha/1.webp"
          alt="ajeet"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Unusual way of getting first Internship:</h3>
            <p>
              I got my first internship through memes. Yeah, you heard it
              right…. Memes. So here it goes, it’s the first year, everyone is
              on social media. For Y20s, WhatsApp was our Campus. Each group
              like a Lecture Hall. When a zoom meet for a course goes on,
              students used to write punch lines and share photos of each
              other’s in chat. I don’t know how, but I got deeply involved in
              that. Y20s started liking my memes. Then I started posting my
              memes on IITKMEMEHUB, with more context of college reopening and
              student life crisis. I was living it as you can say. Then came 2
              nd year, April and one of the seniors at IITKMEMEHUB told me that
              one alumn is looking for a paid content creator and you should
              apply for it. I was nervous, but excited. I told them that I have
              never done anything like this before and I might not succeed. But
              they wanted someone to start from scratch, having seen my work on
              Instagram, they trusted me with this task. This is how I got my
              first intern. I continued doing this internship for 2 years and
              the things I learned gave me enough confidence that I could nail
              my placement.
            </p>
          </div>
        </div>
        <img
          class="blog-image-left"
          src= {ajeet_2}
          alt="ajeet"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Gambled for 2nd Internship:</h3>
            <p>
              I never got any internship through SPO. Many of us in civil didn’t
              even try. To be honest I was scared for the internship season. My
              resume was not at par with other guys and I knew nothing about any
              of the field. I submitted my resume but never gave any internship
              test. I even stopped opening SPO site after one week. I stopped
              applying, there was no interest in me, complete blank.
              <br /> Even for phase 2 I didn’t work hard. In phase 2, Accenture
              came. I applied for it but didn’t give its test. Many of you might
              relate to it. The disinterest in something that you start moving
              away from it. At that time, I was scared that same thing might
              happen during placement season too. I had to make some strategy.
              I’ll tell you about that in next section.
            </p>
            <p>
              I needed an internship for my resume. So, I applied for SIP E
              Cell. I was manager, Design at E Cell, so I knew when it was
              starting. SIP is basically for 2nd year students but 3rd years
              also apply who didn’t get any internship through SPO. I actually
              took interest in this process and started submitting my resume. I
              was sincere, I did all the assignments that they mailed to us.
              Based on this I was selected for a design Intern at VivaHIT. But
              it was an offline internship at Bangalore. They had clearly
              mentioned in their JD.
              <br /> I wanted to stay in campus during summers for CE371 (VKG
              moment here). I mailed the founder of the company explaining my
              condition. I took the risk. I was anxious but luckily the founder
              was sympathetic to my cause and allowed me to do the internship
              online. I was so happy that day. I never thought I would be doing
              2-2 internships at IITK. I would have gotten internship through
              SPO if I had taken interest in it, but got scared away
            </p>
          </div>
        </div>
        <br />
        <br />
        <br />
        <img
          class="blog-image-right"
          src= {ajeet_4}
          style={{ height:"300px", width:"30%"}}
          alt="ajeet"
        />
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Dil Waale ‘Placement’ Le Jaayenge:</h3>
            <p>
              During summers I did my internships, course and also prepared
              little for placement, basically DS and PM role. For placement I
              have to do things differently. <br />
              Based on my experience of internship season, I had to take
              interest in it. I tied up with Shubham. “Sath me apni nayyia
              dubayenge”. It was August 17th I guess when we first got the mail
              for resume submission. <br />
              At that time, I haven’t even started preparing for resume. It was
              same old internship one. Besides preparing resume, I started doing
              aptitude from Indiabix, 2-3 times a day. I made a schedule of it.
              I also started preparing for PM through YouTube videos, all the
              guesstimates problem and how to approach them. That helped me a
              lot during my interviews.
            </p>
            <p>
              I had no intention of going for SDE role, but majority of the
              placement’s tests require coding. I knew I have to take interest
              otherwise same internship type thing will happen. I started
              coding, enough to crack the tests. Leetcode was my go-to at that
              time.{" "}
            </p>
            <p>
              The other thing I did for placement was documenting everything in
              an excel sheet. I note down the company name, when’s their PPT
              presentation, and when’s their test. It was good thing as it
              helped me track. Our placement was little out of order. We had no
              tests schedule during Antaragni. Most of the tests were scheduled
              just 2-3 days before 1st December. My advice would be to start
              preparing for interviews when you have the chance. Don’t wait for
              the last minute.
            </p>
            <>
            Placement Diary:
            <a href="https://docs.google.com/spreadsheets/d/1ILZ1Gm4cPbEXLWGbmlyN40DkIfUt9MxaLRAqgBsYNt8/edit?usp=sharing" target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'underline', fontSize: 'larger' }}>Open Spreadsheet</a>
          </>
          </div>
        </div>
        <img
        className="blog-image-right"
        src="/placement-postulates/blogs/Ajeet-Kushwaha/3.webp"
        style={{ height: "250px", width: "30%" }}
        alt="Ajeet Kushwaha"
      /> 
        <div className="row blog-row">
          <div className="col-md-12">
            <h3>D for December, D for Deloitte:</h3>
            <p>
              I’ll try to break it down to day wise. (Initial shortlist –
              Axxela, Meesho APM, ICICI bank, Deloitte, BatterySmart) Day 1.1 &
              Day 1.2: I didn’t have any interview slot. I waited in hall 1. I
              was anxious about my friend’s placement though. Day 2.1: Meesho
              APM. When I reached at the spot, SPO team told me that my
              interview was converted in GD and after 2 hours of waiting our GD
              was conducted. It was online. Little tip about GD, speak up. Don’t
              sit mook. Take 1 minute, if you have pen paper, write down the
              stuff and start speaking. Try to be the first one to speak. Take
              the lead. (Final result: They didn’t take anyone from GD. Still
              don’t understand why some guys were interviewed and some guys were
              put on GD)
            </p>
            <p>
              Day 2.2: I was sad because of Meesho APM, but angrier on how it
              was conducted. I stayed with my friend Kaushal in Hall 9. In 2nd
              slot, at 10:00 am I went for TATA Project walk-in interview. They
              rejected my resume. At the same time, I rushed for BatterySmart
              GD. Topic: Would you work in Startup or in MNCs. Nailed it. Got in
              2nd round. I was happy that I can do GD. I didn’t prepare for GD
              before. I waited for my turn for interview. They told me its 2 PM
              slot, nothing. 3 PM, still nothing, 4 PM ….. 6PM still nothing
            </p>
            <p>
              BattterySmart people started handing out job offers at the same
              time. I don’t know why some people were given priority during the
              interviews. At home, I didn’t tell anyone about my interviews. I
              didn’t want anyone to worry. At last, at 10 PM, my interview slot
              came. At that point it was clear I wouldn’t get fair shot at
              BatterySmart. Firstly, the interviewers were tired, and secondly,
              they already handed out some job offers.
              <br /> I was angry at them. I had to wait all day because of them.
              Guess what how many minutes my interview was done. Only 10 min.
              Others were given at least 30 minutes. When I went in, they were
              not even interested in my resume. They ask standard questions
              which I answered. But I told them at their face that their hiring
              process is bad. I didn’t care for any retribution at that time. I
              left the interview angrily
            </p>
            <p>
              Day 3: I only had Deloitte and ICICI bank interviews. I had my
              Deloitte interview at 10 AM. I went E5, hall 12. There SPO team
              told me that my interview slot was moved to later. I packed my
              things and went to F5 for ICICI bank GD round. While at F5, I got
              a call from Deloitte that my interviewer was waiting for me. They
              were angry at me that why I didn’t join. I run back to E5, setup
              my laptop in hurry and gave my 1st round. The interviewer asked
              all kinds of questions technical, guesstimates, etc.
              <br /> I knew I nailed it. The interviewer was satisfied with my
              answer. After that I again went to F5 for ICICI bank GD. Topic:
              EV/Hybrid/Traditional vehicle. Cleared this round too. After this
              I got call from SPO that I have to give 2nd round of Deloitte. At
              3 PM, I gave my 2nd round. It was HR round. I had a very good talk
              with the interviewer. I knew that they were going to hire me.{" "}
            </p>
            <p>
              Now comes the “Out of the blue”: At 3PM, I got call from SPO that
              I have my FPL technologies interview from 4 PM. Out of the blue.
              As I was giving my FPL interview, I got call from SPO that I have
              my ICICI bank interview in 10 minutes. I ran from FPL interview to
              ICICI bank. Then I got call from Axxela and Nation with Namo SPO
              teams at the same time that I have their interview. I gave
              priority to Nation with Namo as there was some mishandling with
              Axxela’s interview list.
              <br /> Nation with Namo team asked guesstimated of various kind. I
              had a very cordial chat with the interviewer about politics of UP.
              I went to the last round of Nation with Namo. At the same time, I
              was waiting for Deloitte offer. They were not responding. Around
              9-10 PM, when I was giving my last round of NwN interview I got a
              call from SPO. I stopped the interview and received the call and
              got the good news.
            </p>
            <p>
              Day 3 was wild. Out of blue interviews and all the delaying. My
              advice to whomever reading this would be to have patience. Be
              calm. If you have prepared well, you will definitely get a job.
              Focus on the interview part as well. What’s the use of all that
              skills on your resume if you can’t describe it to your
              interviewer. Try to schedule your interviews as early as possible
              by contacting the POCs of companies you are interviewing,
              otherwise, it would be too late as some companies don't interview
              later or the interviewer gets tired
            </p>
          </div>
        </div>

        <div className="row blog-row">
          <div className="col-md-12">
            <h3>Last Semester:</h3>
            <p>
              I can satisfactorily say that I enjoyed my last semester at IITK.
              I tried everything ;, went to Mathura, Varanasi, and Manali trip
              with my friends. I ended my last two semester with 8+ SPI. I even
              got two A* in my last semester. IIT Kanpur gives you many
              opportunities. I believe I tapped into only 10% of it. But I am
              advising you to tap even further. Go out and explore. Out batch
              Y20 is unique. We started with covid and are ending with
              recession. As of me, I’m still exploring. I don’t want to sit
              idle. My brain will go mad. I want my brain to be always occupied
              with things. Some unexpected things are yet to come from my side.
            </p>
            <p>Best of luck guys!</p>
          </div>
        </div>

        <p>
          <ul>
            <li>
              <b>Resume:</b>{" "}
              <a
                href="https://drive.google.com/file/d/1TrMxOLMIOIPbWcG-Syb8G29NYa6eT_Z0/view"
                className="resume-link"
              >
                [View Resume]
              </a>
            </li>
          </ul>
        </p>
      </div>
    </div>
  );
};

export default Ajeet_Kushwaha;

